import { render, staticRenderFns } from "./LazyAddDocument.vue?vue&type=template&id=0e65179c&scoped=true"
import script from "./LazyAddDocument.vue?vue&type=script&lang=js"
export * from "./LazyAddDocument.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=0e65179c&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/component/badge.css?vue&type=style&index=1&id=0e65179c&prod&scoped=true&lang=css&external"
import style2 from "@/assets/css/component/textarea.css?vue&type=style&index=2&id=0e65179c&prod&scoped=true&lang=css&external"
import style3 from "./LazyAddDocument.vue?vue&type=style&index=3&id=0e65179c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65179c",
  null
  
)

export default component.exports